//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { convertTime } from '../../../../../components/helpers.js'
import { axiosGet } from '../../../../../axios/axios'
import { createFieldConfig, Store } from '../../../../../components/QSelectUtils.js'
import { parseUniqueKey } from '../../ReportCheckListUniqueKey.js'
import ItemsSearchField from '../../../../../components/Field/ItemsSearchField.vue'
import FilesField from '../../../../../components/File/FilesField.vue'
import ImageViewer from '../../../../../components/Images/ImageViewer.vue'

export default {
  components: {
    FilesField,
    ImageViewer,
    ItemsSearchField
  },
  props: {
    report: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      default: null
    },
    reportActionsAccess: {
      type: Object,
      default: null
    },
    resultValue: {
      type: Object,
      default: null
    },
    filesGroup: {
      type: Object,
      default: null
    },
    isNewRecord: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      convertTime: convertTime,
      recordLocal: Object.assign({}, this.resultValue.value.find(rec => rec.time === this.record.time) || this.record),
      selectedPosition: null,
      positionFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchValueMinLength: 1,
        cached: true,
        proxy: {
          urlBase: '/service/obj/search',
          get urlParams () {
            const params = [
              { param: 'unit', type: 'string', action: 'any' }
            ]

            if (this.searchValue) {
              params.push({ param: 'name', type: 'string', action: 'contains', value: this.searchValue, caseSensitive: false })
            }

            return {
              type: 'tool',
              sort: 'name',
              // add: ['unit', 'article'].join(',')
              params: JSON.stringify(params)
            }
          },
          searchCustom: true
        }
      })),
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    filesGroupToCheckForIgnoreDuplicate: function () {
      return this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
    },
    readonly: function () {
      return !this.reportActionsAccess.editData
    }
  },
  watch: {
    selectedPosition: {
      handler: function (value) {
        if (value) {
          this.recordLocal.toolTypeKey = value.key
          this.recordLocal.toolTypeName = value.name
          this.recordLocal.toolTypeUnit = value['param.unit']
        } else {
          this.recordLocal.toolTypeKey = null
          this.recordLocal.toolTypeName = null
          this.recordLocal.toolTypeUnit = null
        }
      }
    }
  },
  mounted: function () {
    if (this.recordLocal.toolTypeKey) {
      this.getToolType(this.recordLocal.toolTypeKey).then(result => {
        this.selectedPosition = result[0]
      })
    }
  },
  methods: {
    validate: function () {
      let valid = true
      if (this.$refs.position) {
        valid &= this.$refs.position.validate()
      }
      if (this.$refs.amount) {
        valid &= this.$refs.amount.validate()
      }
      return valid
    },
    getToolType: function (key) {
      this.loading = true
      const params = [
        { param: '$key', type: 'string', action: '=', value: key },
        { param: 'unit', type: 'string', action: 'any' }
      ]
      const encodeParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&type=' + 'tool',
        onSuccess: (response) => response.data.result
      }).finally(() => {
        this.loading = false
      })
    },
    onFileAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    },
    onRemovePhoto: function ({ file, filesGroup }, record) {
      filesGroup.removeFile(file)
      this.recordLocal.photo = this.recordLocal.photo.filter(id => id !== file.document.id)
    },
    onUploadSuccessPhoto: function ({ document }, record) {
      const rec = this.resultValue.value.find(rec => record.time === rec.time)
      rec.photo.push(document.id)
    },
    onApply: async function () {
      if (this.validate()) {
        if (this.isNewRecord) {
          this.resultValue.value.push(this.recordLocal)
        } else {
          const recordIndex = this.resultValue.value.findIndex(rec => rec.time === this.recordLocal.time)
          this.$set(this.resultValue.value, [recordIndex], this.recordLocal)
        }
        try {
          this.loading = true

          await this.filesGroup.saveFilesChanges({
            notify: true,
            target: this
          })

          this.loading = false
          this.$emit('cancel')
          return true
        } catch (err) {
          this.$q.notify({
            type: 'negative',
            message: err.message,
            progress: true,
            timeout: 8000
          })
          this.loading = false
          return false
        }
      }
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
